import reducers from "./reducers";

export default [
  {
    id: "@pdm/pdp",
    reducerMap: reducers,
  },
];
